// /**
//  * icon references can be found here: https://fontawesome.com/icons?d=gallery&m=pro
//  */

// import { library } from '@fortawesome/fontawesome-svg-core';
// import {
//     faChevronRight,
//     faChevronUp,
//     faChevronDown,
//     faBuilding,
//     faUserCircle,
//     faArrowRight,
//     faArrowLeft,
//     faReply,
//     faPrint,
//     faDownload,
//     faPennant,
//     faFilter,
//     faShareAlt,
//     faUsers,
//     faUser as faUserSolid,
//     faStar,
//     faBell,
//     faSignOut as faSignOutSolid,
//     faSearch,
//     faPlusCircle,
//     faCog,
//     faUpload
// } from '@fortawesome/pro-solid-svg-icons';
// import {
//     // faBell,
//     faSignOut,
//     faArrowAltFromLeft,
//     faArrowAltToLeft,
//     faChartLine,
//     faCogs,
//     faKey,
//     faHandsHelping,
//     faChevronRight as faCRReg,
//     faChevronLeft,
//     faChevronDoubleLeft,
//     faChevronDoubleRight,
//     faThumbtack,
//     faPlus,
//     faTimes,
//     faTrash,
//     faTag,
//     faMapMarker,
//     faEdit,
//     faDraftingCompass,
//     faCheckCircle,
//     faStickyNote,
//     faImage,
//     faImages,
//     faHandshake,
//     faHistory,
//     faTasks,
//     faUser
// } from '@fortawesome/pro-regular-svg-icons';
// import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';

// library.add(
//     faCRReg,
//     faChevronDoubleLeft,
//     faChevronDoubleRight,
//     faChevronLeft,
//     faChevronRight,
//     faChevronUp,
//     faChevronDown,
//     faBuilding,
//     faChartLine,
//     faKey,
//     faCog,
//     faHandsHelping,
//     faBell,
//     faUser,
//     faUserCircle,
//     faSignOut,
//     faArrowAltFromLeft,
//     faArrowAltToLeft,
//     faCogs,
//     faThumbtack,
//     faPlus,
//     faTimes,
//     faTrash,
//     faTag,
//     faArrowRight,
//     faArrowLeft,
//     faReply,
//     faMapMarker,
//     faEdit,
//     faDraftingCompass,
//     faCheckCircle,
//     faStickyNote,
//     faImage,
//     faImages,
//     faHandshake,
//     faHistory,
//     faTasks,
//     faPrint,
//     faDownload,
//     faPennant,
//     faTrashAlt,
//     faFilter,
//     faShareAlt,
//     faUsers,
//     faUserSolid,
//     faStar,
//     faSignOutSolid,
//     faSearch,
//     faPlusCircle,
//     faUpload
// );
